// API Configuration URLs
const backUrl = "https://api.shaku.tech";
// const backUrl = "https://api.shaku.tech";
const subUrl = "";
/*const backUrl='';*/
export { backUrl, subUrl };
